import React from 'react';
import PropTypes from 'prop-types';

import {TableCell, TableRow} from "@mui/material";

import {greyishBlue100, greyishBlue600} from "assets/jss/main";

import {UserAgentUtils} from "utils/useragent";

TopTableHeader.propTypes = {
    headers: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.node,
        align: PropTypes.oneOf(['left', 'center', 'right'])
    })).isRequired
};

function TopTableHeader({headers}) {
    return (
        <TableRow sx={{backgroundColor: "#F8F9FA"}}>
            {headers.map((h, i) => (
                <TableCell
                    key={i}
                    align={h.align}
                    sx={{
                        maxHeight: '48px',
                        color: greyishBlue600,
                        fontSize: UserAgentUtils.isMobile() ? '13px' : '14px',
                        fontWeight: 400,
                        textTransform: "uppercase",
                        borderBottom: `1px solid ${greyishBlue100}`,
                        borderTop: `1px solid ${greyishBlue100}`,
                        py: '15px',
                        pl: i === 0 ? "20px" : '10px',
                        pr: i === headers.length - 1 ? "20px" : '10px',
                        lineHeight:'normal'
                    }}
                >
                    {h.label}
                </TableCell>
            ))}
        </TableRow>
    );
}

export default TopTableHeader;
